import { delay, takeLatest, put, all, select, call, fork, take, cancelled, takeEvery } from "redux-saga/effects";
import { eventChannel } from 'redux-saga';

export const getState = (state) => state;

const listenMessageChannelSaga = function* () {
  
  const postMessage = eventChannel((emitter) => {
    window.addEventListener('message', emitter);
    return () => window.removeEventListener('message', emitter);
  });
  yield takeEvery(postMessage, function*(action) {

    console.log(action)

    if (action.data === 'undefined') {
      return;
    }

    if (!("action" in action.data)) {
      return;
    }

    console.log(action);

    switch (action.data.action) {
      case 'setInit':
        yield put({type: 'SET_INIT', ...action.data });
        yield put({ type: 'INIT_WIDGET', uuid: action.data.uuid });
        break;
      default:
        console.log('action not found');
    }

  });
}

export const startMessageChannel = function* () {
  yield call(listenMessageChannelSaga);
};
